import React, { useEffect, useState } from "react";
import Style from "../../style/travelcity.module.scss";

const TravelCity = () => {
  const [cities, setCities] = useState<any[]>([]);

  useEffect(() => {
    fetch("/data/travel.json")
      .then((res) => res.json())
      .then((data) => {
        const allCities:any = data.agencies.map((agency: any) => agency.city);
        const uniqueCities:any = Array.from(new Set(allCities)).sort();
        setCities(uniqueCities);
      });
  }, []);

  return (
    <section className={Style.metroSection}>
      <h2 className={Style.metroHeading}>Metro Cities We Serve</h2>
      <div className={Style.metroCities}>
        {cities.slice(0,50).map((city, idx) => (
          <a key={idx} href={`/${city}`} className={Style.metroCityLink}>
            {city}
          </a>
        ))}
      </div>
    </section>
  );
};

export default TravelCity;
